import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all form items
export const getFormItems = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-items`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-items:", error.response?.data || error);
    throw error;
  }
};

// GET a single form item
export const getFormItemById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-items/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form-items:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new form item
export const createFormItem = async (formItemData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-items`, formItemData);
    return response.data;
  } catch (error) {
    console.error("Error creating form-items:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing form item
export const updateFormItem = async (id, formItemData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-items/${id}`, formItemData);
    return response.data;
  } catch (error) {
    console.error("Error updating form-items:", error.response?.data || error);
    throw error;
  }
};

// DELETE a form item
export const deleteFormItem = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-items/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting form-items:", error.response?.data || error);
    throw error;
  }
};
